import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Spinner, Table } from 'telia-front-react';
import BillingStore, { ServiceNumber } from '../stores/BillingStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { applyBusinessLogic } from './ServiceNumbersUtil';

export interface ServiceNumbersProps {
  billingStore?: BillingStore;
  showServiceNumbers?: boolean;
  showDonationNumbers?: boolean;
}

@observer
class ServiceNumbers extends React.Component<ServiceNumbersProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public componentDidMount() {
    this.props.billingStore.subscribe();
  }

  public componentWillUnmount() {
    this.props.billingStore.unsubscribe();
  }

  private renderTableServiceNumbers(serviceNumbers: ServiceNumber[]) {
    const translate = this.context.translate;
    return (
      <Table>
        <thead>
          <tr>
            <th>{translate('serviceNumber.number')}</th>
            <th>{translate('serviceNumber.supplementaryNumbers')}</th>
            <th>{translate('serviceNumber.specialTariff')}</th>
            <th>{translate('serviceNumber.serviceProvider')}</th>
            <th>{translate('serviceNumber.serviceName')}</th>
            <th>{translate('serviceNumber.extraInfo')}</th>
          </tr>
        </thead>
        <tbody>
          {serviceNumbers &&
            serviceNumbers.map((serviceNumber) => (
              <tr key={serviceNumber.number}>
                <td>{serviceNumber.number}</td>
                <td>{!!serviceNumber.supplementaryNumbers && serviceNumber.supplementaryNumbers.join(', ')}</td>
                <td>
                  {serviceNumber.price} {serviceNumber.priceDescription}
                </td>
                <td>{serviceNumber.serviceProvider}</td>
                <td>{serviceNumber.serviceName}</td>
                <td>
                  {serviceNumber.extraInfos &&
                    serviceNumber.extraInfos.map((extraInfo) => (
                      <div key={extraInfo}>
                        {extraInfo}
                        <br />
                      </div>
                    ))}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  }

  private renderTableDonationNumbers(donationNumbers: ServiceNumber[]) {
    const translate = this.context.translate;
    return (
      <Table>
        <thead>
          <tr>
            <th>{translate('serviceNumber.donationNumber')}</th>
            <th>{translate('serviceNumber.supplementaryNumbers')}</th>
            <th>{translate('serviceNumber.callPrice')}</th>
            <th>{translate('serviceNumber.donationProvider')}</th>
          </tr>
        </thead>
        <tbody>
          {donationNumbers &&
            donationNumbers.map((donationNumber) => (
              <tr key={donationNumber.number}>
                <td>{donationNumber.number}</td>
                <td>{!!donationNumber.supplementaryNumbers && donationNumber.supplementaryNumbers.join(', ')}</td>
                <td>{donationNumber.price ? `${donationNumber.price} €` : ''}</td>
                <td>{donationNumber.serviceProvider}</td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  }

  public render() {
    const { billingStore, showServiceNumbers, showDonationNumbers } = this.props;
    if (billingStore.isNumbersFetching()) {
      return <Spinner />;
    }

    const numbers = applyBusinessLogic(billingStore.numberList, this.context.translate);
    if (showServiceNumbers) {
      const serviceNumbers = numbers.filter((serviceNumber) => serviceNumber.clearingType !== 5);
      return <>{this.renderTableServiceNumbers(serviceNumbers)}</>;
    } else if (showDonationNumbers) {
      const donationNumbers = numbers.filter((serviceNumber) => serviceNumber.clearingType === 5);
      return <>{this.renderTableDonationNumbers(donationNumbers)}</>;
    }
    return null;
  }
}

export default inject('billingStore')(ServiceNumbers);
